import ErrorBoundary from '@common/components/ErrorBoundary';
import { loadGoogleTagManager } from '@common/lib/googleTagManager';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router';
import { applyMiddleware, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import theme from '../../common/lib/theme';
import { isConsoleWindow } from './common/window';
import AppContainer from './containers/AppContainer';
import validator from './middleware/validator/validator';
import reducer from './reducers';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const store = createStore(reducer, {}, applyMiddleware(thunk, validator));

const renderConsole = () => {
  if (isConsoleWindow(window)) {
    const gon = window.gon;
    if (
      gon.googleTagManager?.containerId &&
      gon.googleTagManager.auth &&
      gon.googleTagManager.preview
    ) {
      loadGoogleTagManager(
        gon.googleTagManager.containerId,
        gon.googleTagManager.auth,
        gon.googleTagManager.preview
      );
    }
  }

  const container = document.getElementById('root');
  if (container) {
    const root = createRoot(container);
    root.render(
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              adapterLocale="ja"
              dateFormats={{
                month: 'MM月',
                year: 'YYYY年',
                fullDate: 'YYYY年MM月DD日',
                keyboardDate: 'YYYY年MM月DD日'
              }}
            >
              <ErrorBoundary>
                <Router>
                  <AppContainer />
                </Router>
              </ErrorBoundary>
            </LocalizationProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </Provider>
    );
  }
};

export default renderConsole;
